import React from 'react';
import styled from 'styled-components';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';
import { useLanguageStore } from '../../../shared/store/languageStore';
import { getVenueFilterLabel } from '../../../shared/util/venueTypeLabel';

interface FilterStationVenueOpenTodayProps {
  currentFilter: VenueFilterData;
  setCurrentFilter: (filter: VenueFilterData) => void;
}

const FilterStationVenueOpenToday: React.FC<FilterStationVenueOpenTodayProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const language = useLanguageStore((s) => s.language);

  return (
    <OpenTodayFilterComp>
      <OpenTodaySubTitle>
        {getVenueFilterLabel('TODAY_OPEN', language)}
      </OpenTodaySubTitle>
      <CheckboxComp>
        <UniversalCheckbox
          checked={currentFilter.openToday}
          onChange={() => setCurrentFilter({
            ...currentFilter,
            openToday: !currentFilter.openToday,
          })}
        />
        {getVenueFilterLabel('OPEN_TODAY', language)}
      </CheckboxComp>
    </OpenTodayFilterComp>
  );
};

export default FilterStationVenueOpenToday;

const OpenTodaySubTitle = styled.div`
  margin-bottom: 1.2vh;
  ${({ theme }) => theme.typography.Body_03_1};
`;

const OpenTodayFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;
